// extracted by mini-css-extract-plugin
export default {"container":"static-data_container__1BLxM","title":"static-data_title__zbX+X"};